import { Music, Video, Image, Box } from 'lucide-react'

export const appConfig = {
  audio: {
    id: 'audio',
    name: 'AUDIO EDITOR',
    description: 'Web-based Digital Audio Workstation',
    url: import.meta.env.VITE_AUDIO_APP_URL || 'https://audio.headstate.studio',
    devUrl: 'http://localhost:3001',
    subdomain: 'audio',
    color: '#4F98FF',
    icon: Music,
    status: 'ACTIVE',
    seo: {
      title: 'Free Online DAW - Audio Editor | Headstate Studio',
      description: 'Professional free digital audio workstation (DAW) in your browser.',
      keywords: 'free DAW, online audio editor, web-based DAW',
    },
  },
  video: {
    id: 'video',
    name: 'VIDEO EDITOR',
    description: 'Video Editing Suite',
    url: import.meta.env.VITE_VIDEO_APP_URL || 'https://video.headstate.studio',
    devUrl: 'http://localhost:3002',
    subdomain: 'video',
    color: '#FFC837',
    icon: Video,
    status: 'ACTIVE',
    seo: {
      title: 'Free Online Video Editor | Headstate Studio',
      description: 'Edit videos online for free with our powerful browser-based video editor.',
      keywords: 'free video editor, online video editing',
    },
  },
  image: {
    id: 'image',
    name: 'IMAGE EDITOR',
    description: 'Image Editor',
    url: import.meta.env.VITE_IMAGE_APP_URL || 'https://image.headstate.studio',
    devUrl: 'http://localhost:3003',
    subdomain: 'image',
    color: '#FF6B6B',
    icon: Image,
    status: 'ACTIVE',
    seo: {
      title: 'Free Online Image Editor | Headstate Studio',
      description: 'Edit images online for free with our powerful browser-based image editor.',
      keywords: 'free image editor, online photo editor',
    },
  },
  '3d': {
    id: '3d',
    name: '3D EDITOR',
    description: '3D Engine',
    url: import.meta.env.VITE_3D_APP_URL || 'https://3d.headstate.studio',
    devUrl: 'http://localhost:3004',
    subdomain: '3d',
    color: '#00D2FF',
    icon: Box,
    status: 'ACTIVE',
    seo: {
      title: 'Free Online 3D Editor | Headstate Studio',
      description: 'Create 3D models and scenes online for free with our browser-based 3D editor.',
      keywords: 'free 3D editor, online 3D modeling',
    },
  },
}

export const apps = Object.values(appConfig)
